import { useEffect, useState } from "react";
/**
 * Признак «пользователь уже создавал песню» (persist в localStorage).
 *
 * Нужен, чтобы показывать вкладку «Мои песни» в сайдбаре гостю/новичку только
 * после того, как он что-то создал — иначе гость не найдёт свои песни (для
 * гостя таб раньше был скрыт, т.к. гейтился на isAuthenticated). Флаг вечный:
 * один раз создал → таб виден и в следующих заходах (пока жива guest-cookie).
 */
const KEY = "tp_has_created_songs";
const EVENT = "tp-has-created-songs";
export function markHasCreatedSongs() {
    try {
        if (localStorage.getItem(KEY) === "1") {
            return;
        }
        localStorage.setItem(KEY, "1");
    }
    catch {
        /* private mode — таб просто не запомнится между сессиями */
    }
    try {
        window.dispatchEvent(new Event(EVENT));
    }
    catch {
        /* ignore */
    }
}
export function getHasCreatedSongs() {
    try {
        return localStorage.getItem(KEY) === "1";
    }
    catch {
        return false;
    }
}
/** Реактивная версия: обновляется в тот же кадр, когда песню создали. */
export function useHasCreatedSongs() {
    const [value, setValue] = useState(getHasCreatedSongs);
    useEffect(() => {
        const sync = () => setValue(getHasCreatedSongs());
        window.addEventListener(EVENT, sync);
        window.addEventListener("storage", sync);
        return () => {
            window.removeEventListener(EVENT, sync);
            window.removeEventListener("storage", sync);
        };
    }, []);
    return value;
}
